import { useTranslation } from 'react-i18next';

export default function Services() {
  const { t } = useTranslation();

  const services = [
    {
      icon: 'ri-bug-line',
      title: t('service1Title'),
      description: t('service1Description'),
      features: [t('service1Feature1'), t('service1Feature2'), t('service1Feature3'), t('service1Feature4')]
    },
    {
      icon: 'ri-code-s-slash-line',
      title: t('service2Title'),
      description: t('service2Description'),
      features: [t('service2Feature1'), t('service2Feature2'), t('service2Feature3'), t('service2Feature4')]
    },
    {
      icon: 'ri-cloud-line',
      title: t('service3Title'),
      description: t('service3Description'),
      features: [t('service3Feature1'), t('service3Feature2'), t('service3Feature3'), t('service3Feature4')]
    },
    {
      icon: 'ri-settings-3-line',
      title: t('service4Title'),
      description: t('service4Description'),
      features: [t('service4Feature1'), t('service4Feature2'), t('service4Feature3'), t('service4Feature4')]
    },
    {
      icon: 'ri-speed-line',
      title: t('service5Title'),
      description: t('service5Description'),
      features: [t('service5Feature1'), t('service5Feature2'), t('service5Feature3'), t('service5Feature4')]
    },
    {
      icon: 'ri-shield-check-line',
      title: t('service6Title'),
      description: t('service6Description'),
      features: [t('service6Feature1'), t('service6Feature2'), t('service6Feature3'), t('service6Feature4')]
    }
  ];

  const servicesSchema = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    'itemListElement': services.map((service, index) => ({
      '@type': 'ListItem',
      'position': index + 1,
      'item': {
        '@type': 'Service',
        'name': service.title,
        'description': service.description,
        'provider': {
          '@type': 'Organization',
          'name': 'Debug',
          'url': 'https://debuging.com/'
        }
      }
    }))
  };

  return (
    <section id="services" className="py-24 bg-white" itemScope itemType="https://schema.org/ItemList">
      <script type="application/ld+json">
        {JSON.stringify(servicesSchema)}
      </script>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-[rgb(0,0,139)]/10 rounded-full px-4 py-2 mb-4">
            <span className="text-[rgb(0,0,139)] text-sm font-semibold">{t('ourServices')}</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('servicesTitle')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('servicesDescription')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100 cursor-pointer group"
              itemScope
              itemProp="itemListElement"
              itemType="https://schema.org/ListItem"
            >
              <meta itemProp="position" content={String(index + 1)} />
              <div itemScope itemType="https://schema.org/Service" itemProp="item">
                <div className="w-14 h-14 bg-[rgb(0,0,139)] rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
                <h3 itemProp="name" className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p itemProp="description" className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-700">
                      <i className="ri-check-line text-[rgb(0,0,139)] mr-2"></i>
                      <strong>{feature}</strong>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}